import React from 'react';
import { motion } from 'framer-motion';
import {
  Sparkles,
  Users,
  ChevronRight
} from 'lucide-react';

export function SupportGroups() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white p-6 md:p-8 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-xl mx-auto text-center bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100"
      >
        <div className="flex flex-col items-center justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-purple-100 flex items-center justify-center mb-4">
            <Users size={40} className="text-purple-600" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Support Groups Coming Soon!</h1>
          <p className="text-lg md:text-xl text-gray-600">
            We're building a supportive community to help you connect with others facing similar challenges.
          </p>
        </div>
        <p className="text-gray-500 mb-6">
          Stay tuned for a wide range of support groups tailored to your needs.
        </p>
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => window.history.back()}
          className="bg-purple-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:bg-purple-700 transition-colors flex items-center justify-center gap-2 mx-auto"
        >
          Go Back <ChevronRight size={20} />
        </motion.button>
      </motion.div>
    </div>
  );
} 